module.exports = __webpack_public_path__ + "static/glur-08e930de1422b5226e10c9cd5bf9229c.svg";